import { Asterisk } from "lucide-react";
import { VARIANT } from "@/constants/links";

const isVip = VARIANT === "vip";

const ITEMS_STANDARD = [
  "Protezione tempo schermo",
  "Geolocalizzazione sicura",
  "Regole per ogni app",
  "Protezione anche offline",
  "Notifiche in tempo reale",
  "Pace mentale per i genitori",
];

// VIP: elenca le capacita' reali del prodotto (registro feature), cosi' il nastro
// in home comunica subito l'ampiezza della supervisione avanzata.
const ITEMS_VIP = [
  "Chat WhatsApp complete",
  "Messaggi eliminati",
  "Registro chiamate",
  "Fotocamera in diretta",
  "Registrazione video",
  "Foto segreta",
  "Ascolto ambientale",
  "Screenshot remoti",
  "Siti visitati",
  "Posizione e aree sicure",
  "Rubrica contatti",
  "Utilizzo app",
  "SMS",
  "Comandi a distanza",
];

const ITEMS = isVip ? ITEMS_VIP : ITEMS_STANDARD;

export const Ticker = () => (
  <div className="relative z-10 -my-3" style={{ overflowX: "clip" }}>
    <div className="-rotate-1 scale-[1.02] bg-yellow py-4 shadow-lg md:py-5">
      <div className="animate-marquee flex w-max">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center">
            {ITEMS.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="flex items-center gap-6 whitespace-nowrap px-6 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-ink sm:text-base"
              >
                {item}
                <Asterisk size={18} className="text-violet" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);
